import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import InventoryUpdate from "./InventoryUpdate";
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { getagentlist, getCorporatedetail, roomlistdetail, SaveBulRoomRates } from "../../Services/Service";


const RateUpdateForm = () => {
  const [loading, setLoading] = useState(false);
  const [contractType, setContractType] = useState("Property");
  const [agentList, setAgentList] = useState([]);
  const [corporateList, setCorporateList] = useState([]);


  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateRange, setDateRange] = useState(false);
  const [selectedDays, setSelectedDays] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]); // Initially empty

  const [rates, setRates] = useState({});
  const [rooms, setRooms] = useState([]);
  const [expandedRoomIndex, setExpandedRoomIndex] = useState(null);
  const [ratePlans, setRatePlans] = useState({});
  const [selectedAgent, setSelectedAgent] = useState(null);       // full agent object
  const [selectedCorporate, setSelectedCorporate] = useState(null); // full corporate object

  const location = useLocation();

  // 🔹 Preselect Agent/Corporate based on query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rParam = params.get("R");   // e.g. "TA-185" or "CP-10"

    if (rParam && rParam.startsWith("TA-")) {
      const loginId = rParam.replace("TA-", ""); // "185"
      setContractType("TA");

      getagentlist().then((data) => {
        if (Array.isArray(data)) {
          const filtered = data.filter(agent => agent.AgentID && (agent.AgentCode || agent.TA_Name));
          setAgentList(filtered);

          const agent = filtered.find(a => String(a.LoginID) === String(loginId));
          if (agent) setSelectedAgent(agent);
        }
      });
    }

    if (rParam && rParam.startsWith("CP-")) {
      const loginId = rParam.replace("CP-", "");
      setContractType("Corporate");

      getCorporatedetail().then((data) => {
        if (Array.isArray(data)) {
          const filtered = data.filter(corp => corp.CorporateID && corp.CorporateCode);
          setCorporateList(filtered);

          const corp = filtered.find(c => String(c.LoginID) === String(loginId));
          if (corp) setSelectedCorporate(corp);
        }
      });
    }
  }, [location.search]);

  // useEffect(() => {
  //   const loadRooms = () => {
  //     const storedRooms = JSON.parse(localStorage.getItem("roomList")) || [];
  //     console.log("room data", storedRooms);
  //     setRooms(storedRooms);

  //     const generatedRatePlans = {};
  //     storedRooms.forEach((room, index) => {
  //       try {
  //         const plans = room.RatePlanDetails ? JSON.parse(room.RatePlanDetails) : [];
  //         generatedRatePlans[index] = plans;
  //       } catch (err) {
  //         console.error("Error parsing RatePlanDetails for room", room.RoomID, err);
  //         generatedRatePlans[index] = [];
  //       }
  //     });
  //     setRatePlans(generatedRatePlans);

  //     const index = localStorage.getItem("selectedRateRoomIndex");
  //     if (index !== null) setExpandedRoomIndex(Number(index));
  //   };

  //   loadRooms(); // initial load

  //   // Listen for localStorage changes
  //   window.addEventListener("storage", loadRooms);
  //   return () => window.removeEventListener("storage", loadRooms);
  // }, []);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        setLoading(true);
        const response = await roomlistdetail();
        // console.log("API se Room List:", response);

        if (Array.isArray(response)) {
          setRooms(response);

          // parse RatePlanDetails for each room
          const generatedRatePlans = {};
          response.forEach((room, index) => {
            try {
              const plans = room.RatePlanDetails ? JSON.parse(room.RatePlanDetails) : [];
              generatedRatePlans[index] = plans;
            } catch (err) {
              console.error("Error parsing RatePlanDetails for room", room.RoomID, err);
              generatedRatePlans[index] = [];
            }
          });
          setRatePlans(generatedRatePlans);
        }
      } catch (err) {
        console.error("Error fetching room list:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, []);

  const toggleExpand = (index) => {
    setExpandedRoomIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (date) => date.toISOString().split("T")[0];

    setFromDate(formatDate(today));
    setToDate(formatDate(tomorrow));
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      setDateRange(true);
    } else {
      setDateRange(false);
    }
  }, [fromDate, toDate]);

  const handleDayToggle = (day) => {
    setSelectedDays((prevDays) =>
      prevDays.includes(day)
        ? prevDays.filter((d) => d !== day)
        : [...prevDays, day]
    );
  };


  // const handleInputChange = (e, type) => {
  //   setRates((prevRates) => ({
  //     ...prevRates,
  //     [type]: e.target.value,
  //   }));
  // };

  const handleInputChange = (e, type, roomPlanKey) => {
    const value = e.target.value;
    setRates((prev) => ({
      ...prev,
      [roomPlanKey]: {
        ...prev[roomPlanKey],
        [type]: value,
      },
    }));
  };

  const showSaveButton = (roomIndex) => {
    const planArray = ratePlans[roomIndex] || [];
    return planArray.some((_, planIdx) => {
      const key = `${roomIndex}-${planIdx}`;
      return rates[key] && Object.values(rates[key]).some(val => val !== "");
    });
  };


  useEffect(() => {
    if (contractType === "TA") {
      getagentlist().then((data) => {
        if (Array.isArray(data)) {
          const filtered = data.filter(agent => agent.AgentID && (agent.AgentCode || agent.TA_Name));
          setAgentList(filtered);
        }
      });
      setCorporateList([]);
      setSelectedCorporate(null);
      setSelectedAgent(null);
    } else if (contractType === "Corporate") {
      getCorporatedetail().then((data) => {
        if (Array.isArray(data)) {
          const filtered = data.filter(corp => corp.CorporateID && corp.CorporateCode);
          setCorporateList(filtered);
        }
      });
      setAgentList([]);
      setSelectedAgent(null);
      setSelectedCorporate(null);
    } else {

      setAgentList([]);
      setSelectedAgent(null);
      setCorporateList([]);
      setSelectedCorporate(null);
    }
  }, [contractType]);



  const handleSave = async (roomIndex) => {
    setLoading(true);
    const room = rooms[roomIndex];
    const planArray = ratePlans[roomIndex] || [];

    const details = planArray.map((plan, planIdx) => {
      const key = `${roomIndex}-${planIdx}`;
      const values = rates[key] || {};

      return {
        RoomID: room.RoomID,
        RatePlan: plan.RatePlan,
        ExtraChild: values.child1 || null,
        ExtraChild_B: values.child2 || null,
        ExtraAdultCharge: values.extraAdult || null,
        Adult_1_Rate: values.single || null,
        Adult_2_Rate: values.double || null,
        Adult_3_Rate: values.triple || null,
      };
    });

    const payload = {
      ContractType: contractType,
      daterange: `${fromDate} to ${toDate}`,
      Days: selectedDays.map(day => {
        const map = {
          Sun: "Sunday",
          Mon: "Monday",
          Tue: "Tuesday",
          Wed: "Wednesday",
          Thu: "Thursday",
          Fri: "Friday",
          Sat: "Saturday"
        };
        return map[day] || day;
      }),
      dateFrom: `${fromDate}T00:00:00`,
      dateTo: `${toDate}T00:00:00`,
      // TravelAgent: contractType === "TA" ? Number(selectedAgentID) : undefined,
      // TravelAgent: contractType === "TA" ? Number(selectedAgent?.LoginID) : undefined,
      // TravelAgent: contractType === "Corporate" ? Number(selectedCorporateID) : undefined,
      TravelAgent: contractType === "TA" ? Number(selectedAgent?.LoginID) : contractType === "Corporate" ? Number(selectedCorporate?.LoginID) : undefined,
      Details: details
    };

    const storedConID = localStorage.getItem("BulkRateConID");
    const ConID = storedConID ? parseInt(storedConID) : 0;

    console.log("Final Submit Payload (to API/DB):\n", JSON.stringify({
      ConID,
      ...payload
    }, null, 2));

    try {
      const res = await SaveBulRoomRates(ConID, payload);
      if (ConID === 0) {

        swal("Rates created successfully!", {
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-success",
            },
          },
        });
      } else {
          swal("Rates updated successfully!", {
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-success",
            },
          },
        });
      }
      console.log("API Response:", res);
    } catch (err) {
      console.error("Error saving rates:", err);
      alert("Failed to save rates.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              {/* <InventoryUpdate /> */}

              <div className=" shadow-sm rounded-2 p-3 bg-white " >
                <div >
                  {/* Contract Type */}
                  <div className="row">
                    {/* Contract Type */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="defaultSelect" className="form-label fw-semibold">
                          Choose the contract type
                        </label>
                        <select className="form-control form-select" id="defaultSelect" value={contractType} onChange={(e) => setContractType(e.target.value)} >
                          <option>Property</option>
                          <option>B2C</option>
                          <option>B2B</option>
                          <option value="TA">Travel Agent</option>
                          <option value="Corporate">Corporate</option>
                        </select>
                      </div>

                      {/* Travel Agent Selector */}

                      {contractType === "TA" && (
                        <div className="form-group mt-2">
                          <label className="form-label fw-semibold">Select Travel Agent</label>
                          <select
                            className="form-control form-select"
                            value={selectedAgent?.AgentID || ""}
                            onChange={(e) => {
                              const agent = agentList.find(
                                (a) => a.AgentID === Number(e.target.value)
                              );
                              setSelectedAgent(agent);
                            }}
                          >
                            <option value="">Select Agent</option>
                            {agentList.map((agent) => (
                              <option key={agent.AgentID} value={agent.AgentID}>
                                {`${agent.FirstName || ""} ${agent.MidlleName || ""} ${agent.LastName || ""}`.trim()} (AG_{agent.AgentCode})
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Corporate Dropdown */}
                      {contractType === "Corporate" && (
                        <div className="form-group mt-2">
                          <label className="form-label fw-semibold">Select Corporate</label>

                          <select
                            className="form-control form-select"
                            value={selectedCorporate?.CorporateID || ""}
                            onChange={(e) => {
                              const corp = corporateList.find(c => c.CorporateID === Number(e.target.value));
                              setSelectedCorporate(corp);
                            }}
                          >
                            <option value="">Select Corporate</option>
                            {corporateList.map((corp) => (
                              <option key={corp.CorporateID} value={corp.CorporateID}>
                                {`${corp.FirstName || ""} ${corp.MidlleName || ""} ${corp.LastName || ""}`.trim()} (CP_{corp.CorporateCode})
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>

                    {/* Date Range */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="dateRange" className="form-label fw-semibold">
                          Select dates to update Rate for <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex gap-2">
                          <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                          <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        </div>
                      </div>
                    </div>

                    {/* Day Selector */}
                    <div className="col-md-5">
                      <div className="form-group">
                        <label className="form-label fw-semibold">
                          Selected days ({selectedDays.length})
                        </label>
                        <div className="d-flex flex-wrap gap-1">
                          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, index) => {
                            const isSelected = selectedDays.includes(day);
                            return (
                              <button
                                key={index}
                                type="button"
                                className="me-1 mb-1"
                                style={{ padding: "6px 10px", border: "1px solid", borderRadius: "4px", backgroundColor: isSelected ? "#27548A" : "#e2e2e2", color: isSelected ? "white" : "#333", borderColor: isSelected ? "#007bff" : "#ccc", cursor: "pointer", fontSize: "13px", }} onClick={() => handleDayToggle(day)} >
                                {day}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* Inventory Form */}
              {dateRange && (
                <div className="p-4 mt-3 shadow rounded-2 bg-white">
                  <h5 className="text-dark mb-3">Update Rates Below</h5>
                  <hr />

                  {rooms.map((room, index) => (
                    <div key={room.RoomID} className="mb-4">
                      <div
                        className="room-card p-3 shadow-sm rounded d-flex justify-content-between align-items-center"
                        style={{ backgroundColor: "#f9f9f9", cursor: "pointer" }}
                        onClick={() => toggleExpand(index)}
                      // onClick={() => setExpandedRoomIndex(prev => prev === index ? null : index)}
                      >
                        <div>
                          <h4>{room.RoomName}</h4>
                          <p>Base Occupancy : 2</p>
                        </div>
                        <div className="rate-restriction">
                          RATE RESTRICTIONS{" "}
                          <i className={`mx-1 fas ${expandedRoomIndex === index ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                        </div>
                      </div>

                      {expandedRoomIndex === index && (
                        <div className="expanded-section p-3 mt-3 shadow-sm rounded bg-light">
                          {ratePlans[index]?.length > 0 ? (
                            <>
                              {ratePlans[index].map((plan, planIdx) => {
                                const key = `${index}-${planIdx}`;
                                return (
                                  <div key={key} className="position-relative mb-4 p-4 border rounded">
                                    <h5 className="text-dark position-absolute bg-white rounded-2" style={{ top: "-13px", paddingInline: "10px" }}>( {plan.RatePlan} )</h5>
                                    <h6 className="mt-4">Sell Rates for :</h6>

                                    <div className="row g-3">
                                      {["single", "double", "triple"].map((type, i) => (
                                        <div className="col-md-4 d-flex align-items-center gap-2" key={type}>
                                          <div className="border rounded shadow-sm p-2 d-flex align-items-center">
                                            <span className="me-1">{i + 1}</span>
                                            <i className="fas fa-user-alt"></i>
                                          </div>
                                          <div className="d-flex border rounded overflow-hidden w-100">
                                            <div className="bg-secondary text-white px-3 d-flex align-items-center">INR</div>
                                            <input
                                              type="number"
                                              className="form-control border-0"
                                              min={0}
                                              placeholder="0.00"
                                              value={rates[key]?.[type] || ""}
                                              onChange={(e) => handleInputChange(e, type, key)}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                      {[{ label: "Extra Adult Charge", key: "extraAdult" }, { label: "Extra Child 1 (0 - 6 years) Charge", key: "child1" }, { label: "Extra Child 2 (7 - 12 years) Charge", key: "child2" }].map(({ label, key: k }) => (
                                        <div className="col-md-4 align-items-center gap-2" key={k}>
                                          <label className="fw-bold">{label}</label>
                                          <div className="d-flex border rounded overflow-hidden w-100">
                                            <div className="bg-secondary text-white px-3 d-flex align-items-center">INR</div>
                                            <input
                                              type="number"
                                              className="form-control border-0"
                                              placeholder="0.00"
                                              min={0}
                                              value={rates[key]?.[k] || ""}
                                              onChange={(e) => handleInputChange(e, k, key)}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                );
                              })}

                              {showSaveButton(index) && expandedRoomIndex === index && (
                                <div
                                  style={{
                                    position: "fixed",
                                    bottom: "0",
                                    left: "0",
                                    right: "0",
                                    backgroundColor: "white",
                                    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                                    padding: "15px 30px",
                                    zIndex: 999,
                                    display: "flex",
                                    justifyContent: "flex-end"
                                  }}
                                >
                                  <button className="btn btn-dark px-4 py-2" onClick={() => handleSave(index)} >
                                    Save
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="p-3 bg-light text-danger text-center fw-semibold border rounded">
                              No rate plans in this room.
                            </div>
                          )}
                        </div>
                      )}


                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>

        </div>
       
      </div>
    </>
  )
}

export default RateUpdateForm;
